export default __webpack_public_path__ + "static/media/user.f95fda45.svg";